(function () {
    'use strict';
  
    var CONFIG = {
      CARD_SELECTORS: [
        '.grid__item',
        '.limespot-recommendation-box-item',
        '.featured-collection--item',
      ],
  
      GRID_SELECTOR: [
        '#product-grid',
        '.product-grid-container',
      ].join(', '),
  
      ADD_BTN_SELECTOR: [
        '.quick-add__submit',
        'button[name="add"].button',
        '.ls-add-to-cart',
      ].join(', '),
  
      ADD_BTN_IGNORE: [
        '.ls-quick-view-body__add-to-cart',
        '.product-form__submit',
      ].join(', '),
  
      CAROUSEL_SECTION_CLS: [
        '.featured-collection-section',
        '.homepage-featured-products',
        '.featured-callout-slider',
      ].join(', '),
  
      REC_SECTION_CLS: [
        '.ls-recommendation-box',
        '.ls-recommendation-box.featured-list',
      ].join(', '),
  
      REC_HEADING_KEYWORDS: [
        'pair it with',
        'you may also like',
        'recently viewed',
        'more like this',
        'featured',
        'recommended',
        'also like',
        'similar',
        'related'
      ],
  
      CTA_KEYWORDS: [
        'more to explore',
        'view all',
        'explore more',
        'shop all',
        'see all',
        'more like this'
      ]
    };
  
    var _cardPositions = new WeakMap();
    var _totalStamped  = 0;
  
    function stampPositions(container) {
      var cards = findCards(container);
      cards.forEach(function (card) {
        if (!_cardPositions.has(card)) {
          _totalStamped++;
          _cardPositions.set(card, _totalStamped);
          card.setAttribute('data-tpp-position', _totalStamped);
        }
      });
    }
  
    function getPosition(card) {
      return _cardPositions.get(card) || 0;
    }
  
    function observeCollectionGrid() {
      var grid = document.querySelector(CONFIG.GRID_SELECTOR);
      if (!grid) return;
  
      stampPositions(grid);
  
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            stampPositions(node);
            if (isCard(node) && !_cardPositions.has(node)) {
              _totalStamped++;
              _cardPositions.set(node, _totalStamped);
              node.setAttribute('data-tpp-position', _totalStamped);
            }
          });
        });
      });
  
      observer.observe(grid, { childList: true, subtree: true });
    }
  
    function isCard(el) {
      return CONFIG.CARD_SELECTORS.some(function (sel) {
        return el.matches && el.matches(sel);
      });
    }
  
    function findCards(container) {
      return Array.from(
        container.querySelectorAll(CONFIG.CARD_SELECTORS.join(', '))
      );
    }
  
    function getParentCard(el) {
      return el.closest(CONFIG.CARD_SELECTORS.join(', '));
    }
  
    function getProductData(card) {
      if (!card) return {};
  
      var id = card.dataset.productId
        || card.dataset.variantId
        || card.dataset.productIdentifier
        || '';
  
      var title = card.dataset.productTitle
        || card.dataset.productName
        || '';
  
      var price = card.dataset.productPrice
        || card.dataset.price
        || '';
  
      if (!title) {
        var heading = card.querySelector(
          '.card__heading a, .card__name a, .product-card__name a, ' +
          'h2 a, h3 a, h4 a, .h3 a'
        );
        if (heading) title = heading.innerText.trim();
      }
  
      if (!id) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) {
          var match = link.href.match(/\/products\/([^/?#]+)/);
          id = match ? match[1] : '';
        }
      }
  
      var productUrl = '';
      var productLink = card.querySelector('a[href*="/products/"]');
      if (productLink) productUrl = productLink.href;
  
      return {
        item_id: id,
        item_name: title,
        item_price: price,
        item_url: productUrl
      };
    }
  
    function getSectionHeading(el) {
      var section = el.closest('.shopify-section') || el.closest('limespot');
      if (!section) return '';
      var heading = section.querySelector(
        'h1, h2, h3, ' +
        '.collection__title, ' +
        '.section__title, ' +
        '.section-header__title, ' +
        '.ls-box-title, ' +
        '[class*="section-heading"], ' +
        '[class*="section-title"]'
      );
      return heading ? heading.innerText.trim() : '';
    }
  
    function isRecSection(heading) {
      var h = heading.toLowerCase();
      return CONFIG.REC_HEADING_KEYWORDS.some(function (kw) {
        return h.includes(kw);
      });
    }
  
    function insideRecSection(el) {
      var byClass = el.closest(CONFIG.REC_SECTION_CLS);
      if (byClass) return true;
      return false;
    }
  
    function insideCarouselSection(el) {
      return !!el.closest(CONFIG.CAROUSEL_SECTION_CLS);
    }
  
    function isHomepage()   { return document.body.classList.contains('template-index'); }
    function isCollection() { return document.body.classList.contains('template-collection'); }
    function isProduct()    { return document.body.classList.contains('template-product'); }
  
    function getPageType() {
      if (isHomepage()) return 'homepage';
      if (isCollection()) return 'collection';
      if (isProduct()) return 'product';
      return 'other';
    }
  
    function gtagEvent(eventName, params) {
      if (typeof gtag !== 'function') return;
      gtag('event', eventName, params);
    }
  
    function handleCarouselProductClick(productLink, addBtn) {
      if (addBtn) return;
      if (!insideCarouselSection(productLink)) return;
  
      var card = getParentCard(productLink);
      var data = getProductData(card);
      var position = card ? getPosition(card) : 0;
      var heading = getSectionHeading(productLink);
  
      gtagEvent('carousel_product_click', {
        carousel_name: heading || 'unknown_carousel',
        item_id: data.item_id,
        item_name: data.item_name,
        item_position: position,
        item_url: productLink.href
      });
    }
  
    function handleRecProductClick(productLink, addBtn) {
      if (addBtn) return;
      if (!insideRecSection(productLink)) return;
  
      var card = getParentCard(productLink);
      var data = getProductData(card);
      var position = card ? getPosition(card) : 0;
      var heading = getSectionHeading(productLink);
  
      gtagEvent('rec_product_click', {
        rec_section: heading || 'unknown_rec',
        item_id: data.item_id,
        item_name: data.item_name,
        item_position: position,
        source_page_type: getPageType()
      });
    }
  
    function handleCarouselCtaClick(link) {
      if (link.href && link.href.includes('/products/')) return;
  
      var text = (link.innerText || '').trim().toLowerCase();
      var isCta = CONFIG.CTA_KEYWORDS.some(function (kw) {
        return text.includes(kw);
      });
      if (!isCta) return;
  
      if (!insideCarouselSection(link)) return;
  
      var heading = getSectionHeading(link);
  
      gtagEvent('carousel_cta_click', {
        carousel_name: heading || 'unknown_carousel',
        cta_text: link.innerText.trim(),
        destination_url: link.href
      });
    }
  
    function handleCollectionQuickAdd(addBtn) {
      if(!isCollection()) return;
      if (insideRecSection(addBtn)) return;
  
      var card = getParentCard(addBtn);
      var data = getProductData(card);
      var position = card ? getPosition(card) : 0;
  
      var collectionName = (
        document.querySelector('.collection__title, h1.title, h1')?.innerText?.trim()
        || document.title.replace(/\s[–—-]\s.*/, '').trim()
        || 'unknown_collection'
      );
  
      gtagEvent('collection_quick_add', {
        item_id: data.item_id || addBtn.dataset.productId || '',
        item_name: data.item_name,
        item_price: data.item_price,
        collection_name: collectionName,
        item_position: position
      });
    }

    function handleRecQuickAdd(addBtn) {
        if (isHomepage()) return;
        if (!insideRecSection(addBtn)) return;
    
        var card = getParentCard(addBtn);
        var data = getProductData(card);
        var heading = getSectionHeading(addBtn);
    
        gtagEvent('rec_quick_add', {
          item_id: data.item_id || addBtn.dataset.productId || '',
          item_name: data.item_name,
          item_price: data.item_price,
          rec_section: heading || 'unknown_rec',
          source_page_type: getPageType()
        });
      }    
  
    function handleCarouselQuickAdd(addBtn) {
      if (!insideCarouselSection(addBtn)) return;
  
      var card = getParentCard(addBtn);
      var data = getProductData(card);
      var heading = getSectionHeading(addBtn);
  
      gtagEvent('carousel_quick_add', {
        item_id: data.item_id || addBtn.dataset.productId || '',
        item_name: data.item_name,
        item_price: data.item_price,
        rec_section: heading || 'unknown_rec',
        source_page_type: getPageType()
      });
    }
  
    document.addEventListener('click', function (e) {
  
      var productLink = e.target.closest('a[href*="/products/"]');
      var addBtn = e.target.closest(CONFIG.ADD_BTN_SELECTOR);
      var addBtnIgnore = e.target.closest(CONFIG.ADD_BTN_IGNORE);
      var ctaLink = e.target.closest('.button');
  
      if (!productLink && !addBtn && !ctaLink) return;
  
      if (addBtn && !addBtnIgnore) {
        handleCollectionQuickAdd(addBtn);
        handleCarouselQuickAdd(addBtn);
        handleRecQuickAdd(addBtn);
      }
  
      if (productLink && !addBtn) {
        handleCarouselProductClick(productLink, addBtn);
        handleRecProductClick(productLink, addBtn);
      }
  
      if (ctaLink && !productLink && !addBtn) {
        handleCarouselCtaClick(ctaLink);
      }
  
    }, true);
  
    function init() {
      if (isCollection()) {
        observeCollectionGrid();
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
  })();